import 'src/components/shared/TokenInfo.css'
import { TokenData } from 'src/constants/DataModels'
import TokenIcon from 'src/assets/components/TokenIcon'
import React from 'react'
import { ScanDenomLink } from 'src/components/shared/ScanDenomLink'

type TokenProps = {
  token: TokenData
}

export const TokenInfo = ({ token }: TokenProps) => {
  const { name, denom, symbol, decimals } = token
  return (
    <div className={'token-info'}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
        <TokenIcon token={symbol} className="token-icon"
        /> {symbol} <span className="decimals-pill">{decimals} d.p.</span>
      </div>
      <div><small>{name}</small></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <ScanDenomLink denom={denom} shouldTruncate={true} className={'address-link-token-info'}/>
      </div>
    </div>
  )
}
